export async function passwordReset(newPassword: string, token: string): Promise<boolean> {
    try {
        const response = await fetch('/operations/admin/AJAX-REQUESTS-General.aspx/Reset_Password_Now', {
            body: JSON.stringify({
                Password: newPassword,
                Password_Reset_Object: token
            }),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        });

        const body = await response.json();
        return parseInt(body.d) === 1;
    } catch (error) {
        console.error(error);
    }

    return false;
}
